module.exports = __webpack_public_path__ + "img/Texture.68f87ea7.png";